import { Link } from "react-router-dom";
import { FadeIn, FadeInStagger } from "../../components/utils/FadeIn";
import { PageHeading } from "../../components/utils/pageHeading";
import { ResourceLoading } from "../../components/utils/ResourceLoading";
import { PromangLogo } from "../../components/utils/PromangLogo";
import { ContactCTA } from "../../components/home/ContactCTA";
import { CmsSeo } from "../../components/cms/CmsSeo";
import { usePublicWebPosts } from "../../hooks/usePublicWebPosts";
import {
  documentExcerpt,
  formatPostDate,
  postPath,
} from "../../data/cmsPublic";
import Placeholder from "../../components/images/placeholder.png";

export const PostsIndex = () => {
  const { items, loading, fromApi } = usePublicWebPosts();

  return (
    <>
      <CmsSeo
        document={{
          title: "Innlegg",
          meta_description:
            "Artikler og innlegg om ventilasjon, service og inneklima fra Airon AS.",
          meta_keywords: "ventilasjon, inneklima, service, filter, Airon",
          kind: "page",
        }}
        kind="page"
        path="/innlegg"
      />
      <PageHeading
        eyebrow="Kunnskap"
        title="Innlegg."
        description="Guider og artikler om ventilasjon, service og et sunt inneklima. Innholdet synkes fra Promang."
      />

      <section className="sec tint" style={{ borderTop: "none" }}>
        <div className="wrap">
          <div className="sec-head">
            <div className="sec-tag">Fra Airon</div>
            <h2>
              Les mer om <em>ditt inneklima.</em>
            </h2>
            <div className="source-badge" aria-label="Synkroniseres fra Promang">
              <span className="pulse" />
              <span style={{ fontFamily: "var(--mono)", fontSize: 11 }}>
                {loading
                  ? "Henter fra"
                  : fromApi
                    ? `${items.length} innlegg · synk fra`
                    : "Ingen synk ·"}
              </span>
              <PromangLogo height={14} color="var(--airon-3)" />
            </div>
          </div>

          {loading ? (
            <div style={{ padding: "40px 0" }}>
              <ResourceLoading />
            </div>
          ) : items.length === 0 ? (
            <div
              style={{
                border: "1px dashed var(--line)",
                borderRadius: 20,
                padding: 40,
                background: "#fff",
                textAlign: "center",
              }}
            >
              <h2
                style={{
                  fontFamily: "var(--display)",
                  margin: 0,
                  fontSize: 28,
                }}
              >
                Ingen innlegg publisert ennå
              </h2>
              <p style={{ color: "var(--ink-2)", marginTop: 10 }}>
                Kom tilbake snart, eller se hjelp og FAQ.
              </p>
              <Link to="/hjelp" className="btn" style={{ marginTop: 18 }}>
                Hjelp &amp; FAQ <span className="arr">→</span>
              </Link>
            </div>
          ) : (
            <FadeInStagger>
              <div
                className="projects-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
                  gap: 20,
                }}
              >
                {items.map((post) => (
                  <FadeIn key={post.id || post.slug}>
                    <article
                      className="project"
                      style={{
                        background: "#fff",
                        border: "1px solid var(--line)",
                        borderRadius: 20,
                        padding: 18,
                        display: "flex",
                        flexDirection: "column",
                        gap: 14,
                      }}
                    >
                      <div
                        className="thumb"
                        style={{
                          width: "100%",
                          aspectRatio: "16 / 10",
                          borderRadius: 14,
                          overflow: "hidden",
                          background: "var(--bg-2)",
                        }}
                      >
                        <img
                          src={post.featured_image_url || Placeholder}
                          alt={post.title || ""}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </div>
                      <h3
                        style={{
                          fontFamily: "var(--display)",
                          fontSize: 22,
                          lineHeight: 1.25,
                          margin: 0,
                        }}
                      >
                        <Link
                          to={post.path || postPath(post)}
                          style={{ color: "inherit" }}
                        >
                          {post.title}
                        </Link>
                      </h3>
                      <p
                        style={{
                          margin: 0,
                          fontSize: 14,
                          lineHeight: 1.55,
                          color: "var(--ink-2)",
                        }}
                      >
                        {documentExcerpt(post, "Les mer hos Airon.")}
                      </p>
                      <div
                        style={{
                          marginTop: "auto",
                          paddingTop: 12,
                          borderTop: "1px solid var(--line)",
                          display: "flex",
                          justifyContent: "space-between",
                          fontFamily: "var(--mono)",
                          fontSize: 11,
                          color: "var(--muted)",
                          textTransform: "uppercase",
                          letterSpacing: "0.06em",
                        }}
                      >
                        <span>{post.author_name || "Airon AS"}</span>
                        <span>
                          {formatPostDate(post.published_at || post.created_at)}
                        </span>
                      </div>
                    </article>
                  </FadeIn>
                ))}
              </div>
            </FadeInStagger>
          )}
        </div>
      </section>
      <ContactCTA />
    </>
  );
};

export default PostsIndex;
